module.exports = __webpack_public_path__ + "static/media/S (164).f2c2d33f.jpg";